import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';

export const Container = styled(Grid)`
    padding: 16px;
`;

export const Title = styled(Typography)`
    font-weight: 500;
    font-size: 24px;
    color: #ffffff;
`;

export const Notice = styled(Typography)`
    font-size: 12px;
    color: #dcc6b7;
    margin-top: 4px;
    margin-bottom: 16px;
`;

export const SectionCard = styled('div')`
    background-color: #373435;
    border-radius: 10px;
    margin-bottom: 16px;
    overflow: hidden;
`;

export const SectionScroll = styled('div')`
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #4a4a4a #373435;

    &::-webkit-scrollbar {
        height: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #373435;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #4a4a4a;
        border-radius: 3px;
    }
`;

export const SectionHeader = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 18px;
`;

export const SectionTitle = styled(Typography)`
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
`;

export const Table = styled('div')`
    min-width: fit-content;
`;

export const LoadingWrapper = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px 0;
`;

export const TableRowBase = styled('div')`
    display: flex;
`;

export const TableHeadRow = styled(TableRowBase)`
    background-color: #424242;
`;

export const DataRow = styled(TableRowBase)`
    background-color: #373435;
    border-top: 1px solid #4a4a4a;
`;

export const TotalRow = styled(TableRowBase)`
    background-color: rgba(220, 198, 183, 0.13);
`;

export const TableCell = styled('div')`
    flex: 0 0 ${({ width }) => width || 115}px;
    padding: 11px 14px;
    box-sizing: border-box;
    text-align: ${({ align }) => align || 'right'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${({ sticky, background }) =>
        sticky &&
        `
            position: sticky;
            left: 0;
            z-index: 2;
            background-color: ${background};
        `}
`;

export const TableHeadCellText = styled(Typography)`
    font-weight: 700;
    font-size: 14px;
    color: #dcc6b7;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`;

export const DataCellText = styled(Typography)`
    font-weight: 400;
    font-size: 14px;
    color: ${({ primary }) => (primary ? '#ffffff' : '#e3e3e3')};
`;

export const TotalCellText = styled(Typography)`
    font-weight: ${({ emphasis }) => (emphasis ? 500 : 400)};
    font-size: 14px;
    color: ${({ accent, emphasis }) => {
        if (accent) return '#dcc6b7';
        if (emphasis) return '#ffffff';
        return '#e3e3e3';
    }};
`;

export const SssgButton = styled('button')`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    text-decoration: underline;
    color: inherit;
    width: 100%;
    text-align: right;
`;
